<div id="summary-wrapper" class="divWhiteBackground">
  <form novalidate="" class="formStyle ng-untouched ng-pristine ng-invalid">
    <div class="tnc summary form-group">
      <div
        id="cac-div-summary-termsAndConditions"
        class="cac-osm-summary-consent"
      >
        <label
          id="summary_termsAndConditions"
          class="collapsed"
          [innerHTML]="emailPhoneConsent | safeHtml"
        >
        </label>
        <div class="summary-consent-agree-label">
          <div class="cac-agreement-consent">
            <input
              type="checkbox"
              aria-labelledby="summary_termsAndConditions"
              id="consentAgreed"
              name="consentAgreed"
              [formControl]="summaryConsentAgreed"
              class="ng-untouched ng-pristine ng-invalid"
            />
          </div>
          <div class="name-black pl-10">{{ globalText.iAgree }}</div>
        </div>
      </div>
      <div class="form-group pt-20 center">
        <div class="custom-display-inline">
          <button
            id="cac-summary-submit"
            class="btn btn-primary btn-default w-auto center-button col-right Acceptance-Bold no-upper"
            [class.disabled]="!allConsentsGiven"
            [disabled]="!allConsentsGiven || isWaiting"
            (click)="processFormSubmission()"
          >
            <span *ngIf="isWaiting" class="fa fa-spinner fa-spin"></span>
            {{ this.summary.submit_information }}
          </button>
        </div>
      </div>
    </div>
  </form>
  <div id="g-recaptcha-container" data-size="invisible"></div>
</div>
